import React from "react";
import { config } from "../../config/config";
import { getSdk } from "../../services/sdkService";
import { Detail, withFocusable, Loading } from "../../services/visualLibraryService";
import { getSupportedVideoTechnology } from "../../services/assetTypesService";
import { DetailPageStyled, ArrowScrollStyled } from "./styles/Styled";
import { withAppState, getAppState } from "../../state";
import { startApp } from "../../index";
import { getGlobalButtonFocusPath, getConfigForModalWithCloseButton } from "../../errors/globalButtons";
import sorter from "../../utils/sortObjectsArray";
import { getSpSportsPackageDisplayName, isSpSportsAddonContent } from  "../../services/sportPackageService"; 
import {
  showChannelSubscriptionErrorPopupNew,
  isUserSubscribedToChannel,
  isAddonContent,
  showSportPackageSubscriptionErrorPopup,
  isUserSubscribedToSpSportsChannel,
  isStandAloneAddon,
  isMainPackageAddOn,
  getAddOnByName,
  T20ParentAddOn,
  isT20ParentSubscribed,
  isT20AddOn,
  isCricketAddOn,
  isT20ChildSubscribed,
  CricChildAddOn,
  isCricketAcquiresFrom
} from "../../utils/subscriptionUtils";
import { i18n } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import {
  showResolutionModal,
  showNotLoggedModal,
  showInvalidStatusModal,
  showRetryOrBackModal,
  showForceLogoutError
} from "../../services/modalsService";
import { formatDetailData, getEpisodeLabel } from "../../services/copyService";
import { trackPage, trackEvent, sendUserEvent } from "../../services/analyticsService";
import { getTrailerVideoData, getVideoDataForPlayer, getMediaContentData } from "../../services/mediaService";
import { getUserMediaLists, myListHandler, checkMediaListsData } from "../../services/mediaListService";
import {
  redirectTo,
  trackAndRedirectHandler,
  getNavigationReferences,
  isComingFromDetailPageScope
} from "../../services/navigationService";
import {
  isSuitableFor4KPlayback,
  getTrailer,
  getSeasonsList,
  isSeriesDetailPage,
  getSeasonEpisodeFromMediaGuid,
  findFirstEpisodeBySeason,
  has4KProgramId,
  getEpisodeSelectorData
} from "../../services/titleDataService";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";
import { routes } from "../../routes";
import { makeAddOnsDeep } from "../../utils/addOnsUtil";
import { defaultFocusPath } from "../../components/Header";

const HAS_4K = "4kProgramId";
const MEDIAGUID = "mediaGuid";
const PAGE = "detail";
const PLAY_FROM_LABEL = "details_screen";
const ArrowScrollFocus = withFocusable(ArrowScrollStyled);
let sdk = null;

class DetailPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isExiting = false;
    // FIXME this state is too cluttered (too many elements are added to it when not needed). Not only here, across all the component
    this.state = {
      isLoading: false,
      titleData: null,
      backgroundCover: undefined,
      video: undefined,
      trailer: undefined,
      hasEpisodes: false,
      episodeSelectorLoaded: false,
      isSavedInMyWatchlist: false,
      has4K: false,
      isLoaded: false,
      firstEpisodeAvailable: undefined,
      isPlaying: false
    };
    this.fetchData = this.fetchData.bind(this);
    this.playHandler = this.playHandler.bind(this);
    this.play = this.play.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onBack = this.onBack.bind(this);
    this.isRestarting = false;
    this.props.stateActions.applyKidsTheme();
    this.isSeries = isSeriesDetailPage.call(this);
  }

  async componentWillReceiveProps(newProps) {
    if (newProps.location.pathname !== this.props.location.pathname) {
      if (
        (this.props.location && this.props.location.state && !!this.props.location.state.deepLinkReferrer) ||
        (newProps.location && newProps.location.state && !!newProps.location.state.deepLinkReferrer)
      ) {
        this.setState({ backgroundCover: null, hasEpisodes: false });
        this.props.onRef(this);
      }
      this.props.applicationState.userMediaCached = null;
      this.progress = null;
      this.setState({ titleData: null });
      this.setState({ titleData: await this.fetchData() });
    }
  }

  componentWillUnmount() {
    this.isExiting = true;
    !!getAppState().globalModal && this.props.stateActions.hideGlobalModal();
  }

  async componentDidMount() {
    // Deep call of User Addons to get the payment info for each addons
    makeAddOnsDeep.call(this);

    const getPlatform = await getSdk().systemManager.device.getPlatform();
    this.setState({
      isOnPS4: getPlatform === 'ps4' ? true : false
    })
    const { history, location } = this.props;
    sdk = await getSdk();
    if (!isComingFromDetailPageScope.call(this)) {
      // This will happen when the deep linking is used and in this case the media list cache needs to be removed in
      // order to get the new title's media list data and not show the previous one's.
      this.props.applicationState.userMediaCached = null;
      this.progress = null;
    }

    location.state && !!location.state.deepLinkReferrer && (await startApp());
    trackPage.call(this, PAGE);
    this.setState({
      titleData: await this.fetchData(),
      isLoaded: true,
      isPlaying: false
    });
    this.props.onRef(this);

    // Send event
    !this.state.unAuthorizedAccess &&
      this.props.applicationState.userLogged &&
      this.props.location.referrer.search(/\/(episodes|player)$/) === -1 &&
      this.props.location.referrer !== this.props.location.pathname &&
      sendUserEvent({
        module_id: history.location.state ? history.location.state.moduleId : null,
        id: this.state.id,
        action: "detail_page"
      });
    this.props.setFocus(Detail.defaultFocusPath);
    sdk.playerManager.stop();
      // Force logout listening 
      showForceLogoutError.call(this);
  }

  closeModal(focusPath = Detail.defaultFocusPath) {
    this.props.stateActions.hideGlobalModal();
    this.props.setFocus(focusPath);
  }

  async playHandler(isRestarting) {
    const currentAddOn = getAddOnByName(this.state.addonContent);
    const {
      match: {
        params: { titleId }
      },
      applicationState: { userLogged, userAccountStatus, addons },
      setFocus,
      stateActions
    } = this.props;
    const { addonContent } = this.state;
    let eventAction = (isRestarting === true && "play_from_beginning") || "play";
    trackEvent(PAGE, eventAction, titleId);

    if (userLogged) {
      if (!isUserAccountActive(userAccountStatus) && !isAddonContent(this.state.addonContent)) {
        return showInvalidStatusModal.call(this);
      }

      if(isCricketAddOn(this.state.addonContent) && isCricketAcquiresFrom(this.state.addonContent)){
        if (!isUserSubscribedToChannel(addons, this.state.addonContent) && isT20ChildSubscribed(this.state.addonContent)) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, currentAddOn.displayName);
        } else if (!isUserSubscribedToChannel(addons, this.state.addonContent) && !isT20ChildSubscribed(this.state.addonContent)) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, `${currentAddOn.displayName} & ${CricChildAddOn(this.state.addonContent)?.displayName}`);
        } 
      } else if (isT20AddOn(this.state.addonContent)) {
        if (!isUserSubscribedToChannel(addons, this.state.addonContent) && isT20ParentSubscribed(this.state.addonContent)) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, currentAddOn.displayName);
        } else if (!isUserSubscribedToChannel(addons, this.state.addonContent) && !isT20ParentSubscribed(this.state.addonContent)) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, `${T20ParentAddOn(this.state.addonContent)?.displayName} & ${currentAddOn.displayName}`);
        } 
      } else {
        if (isMainPackageAddOn(this.state.addonContent) && isSpSportsAddonContent(this.state.addonContent) && !isUserSubscribedToSpSportsChannel(addons, this.state.addonContent)) {
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, getSpSportsPackageDisplayName());
        }
        if (!isMainPackageAddOn(this.state.addonContent) && !isStandAloneAddon(this.state.addonContent) && isSpSportsAddonContent(this.state.addonContent) && !isUserSubscribedToSpSportsChannel(addons, this.state.addonContent)) {
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, getSpSportsPackageDisplayName());
        }
        if (!isUserSubscribedToChannel(addons, this.state.addonContent)) {
          return showChannelSubscriptionErrorPopupNew.call(this, this.closeModal);
        }
      }
      
      this.setState({
        isLoaded: false
      }, async () => {
        const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, this.state.addonContent);
        this.setState({ isLoaded: true });
        if (!isThisDeviceSupported) {
          return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
        }

        this.isRestarting = isRestarting;
        if (!!getAppState().isOnline) {
          await showResolutionModal.call(this, isSuitableFor4KPlayback(has4KProgramId.call(this)));
        } else {
          stateActions.showGlobalModal(
            getConfigForModalWithCloseButton(
              {
                title: i18n.get("global.errors.internetConnectivity.title"),
                text: i18n.get("global.errors.internetConnectivity.text")
              },
              this.closeModal.bind(this)
            )
          );
          setFocus(getGlobalButtonFocusPath("close"));
        }
      // Add GA Event on play button if there is no error
      trackEvent("play", "video_play_click", titleId);
      });

    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this));
    }
    return false;
  }


  goPlayer(videoData) {
    const { history } = this.props;
    this.isExiting = true;
    this.setState({
      isPlaying: true
    });
    return redirectTo.call(this, routes.player, {
      ...history.location.state,
      ...videoData
    });
  }

  async play(is4K, isSelectedFromResolutionPopup) {
    const {
      setFocus,
      match: {
        params: { titleId }
      }
    } = this.props;
    const episodesLoaded = !this.isSeries || (await this.episodesLoad);
    const videoData = episodesLoaded && (await getVideoDataForPlayer.call(this, is4K));
    Object.assign(videoData, { playFrom: PLAY_FROM_LABEL });
    isSelectedFromResolutionPopup && trackEvent(PAGE, is4K ? "4K" : "HD", titleId);
    sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
    setFocus(Detail.defaultFocusPath);
    this.goPlayer(videoData);
  }

  onBack() {
    const {
      match: {
        params: { titleId }
      },
      stateActions,
      applicationState,
      location,
      history
    } = this.props;
    const dismissable = applicationState.globalModal && applicationState.globalModal.dismissable;
    trackEvent(PAGE, "back", titleId);
    if (!!applicationState.globalModal) {
      this.closeModal();
      if (!dismissable) {
        return true;
      }
    }
    const isDeepLinkReferrer = location.state && !!location.state.deepLinkReferrer;
    applicationState.userMediaCached = null;

    if (isDeepLinkReferrer) {
      history.push(stateActions.getHomePath(isDeepLinkReferrer, !!this.isSeries), {
        deepLinkReferrer: false
      });
      return true;
    }
    this.isExiting = true;
    history.goBack();
    return true;
  }

  getIconButtonPlay() {
    const {
      applicationState: { addons }
    } = this.props;
    const { addonContent } = this.state;
    return !isUserSubscribedToChannel(addons, addonContent) ? "premiumContentEmpty" : "play";
  }

  async fetchData() {
    sdk = await getSdk();
    try {
      const {
        applicationState: { userLogged },
        match: {
          params: { titleId }
        }
      } = this.props;
      const requests = [
        sdk.mediaManager.getTitle(titleId, {
          is4K: true,
          offline: !getAppState().isOnline
        }), // [0] Title
        userLogged ? await getUserMediaLists(titleId, checkMediaListsData.bind(this)) : true, // [1] User Media
        this.isSeries ? getSeasonsList.call(this, titleId) : [] // [2] Seasons Series
      ];
      const results = requests.map(async req => await req);
      const title = await results[0];

      if (this.isSeries) {
        // FIXME: This should be done in the middleware instead.
        title.mediaContent.sort(sorter(MEDIAGUID));

        // Map the 4K episodes.
        this.title4K = {};
        !!title.title4K &&
          !!title.title4K.mediaContent &&
          title.title4K.mediaContent.forEach(
            media => (this.title4K[getSeasonEpisodeFromMediaGuid(media.mediaGuid)] = media)
          );
      }
      userLogged && (await results[1]);
      const seasons = await results[2];
      const videoType = getSupportedVideoTechnology();

      const firstEpisode =
        this.isSeries && findFirstEpisodeBySeason(title.mediaContent, this.seasonsListRaw[0].tvSeasonNumber);
      const firstEpisodeFromMediaGuid = firstEpisode && getSeasonEpisodeFromMediaGuid(firstEpisode.mediaGuid);
      const firstEpisodeNumber = firstEpisodeFromMediaGuid && parseInt(firstEpisodeFromMediaGuid.split("E")[1]);
      const firstEpisodeAvailable =
        this.isSeries && !this.resumeEpisode
          ? getEpisodeLabel(this.seasonsListRaw[0].tvSeasonNumber, !isNaN(firstEpisodeNumber) && firstEpisodeNumber)
          : undefined;

      const mediaHD = getMediaContentData.call(this, title, false);
      const media4K = !!title.title4K && getMediaContentData.call(this, title.title4K, true);
      this.mediaData = {
        mediaHD,
        media4K,
        videoHD: mediaHD.content.video[videoType] || mediaHD.content.video,
        video4K: !!media4K && (media4K.content.video[videoType] || media4K.content.video)
      };

      this.setState({
        backgroundCover: title.images.hero,
        firstEpisodeAvailable,
        trailer: getTrailer(title),
        title: title.title,
        description: title.shortDescription,
        id: title.id,
        has4K: !!title[HAS_4K],
        addonContent: title.addonContent,
        isLive: title.isLive
      });
      return formatDetailData.call(this, title, seasons);
    } catch (e) {
      !this.isExiting && showRetryOrBackModal.call(this, e);
    }
  }

  render() {
    const {
      backgroundCover,
      isLoading,
      titleData,
      isSavedInMyWatchlist,
      firstEpisodeAvailable,
      hasEpisodes,
      isLoaded,
      episodeSelectorLoaded
    } = this.state;
    return (
      <DetailPageStyled url={backgroundCover}>
        {isLoading && <Loading overlay />}
        <Detail
          data={titleData}
          playHandler={this.playHandler}
          trailerHandler={trackAndRedirectHandler.bind(
            this,
            PAGE,
            "trailer",
            routes.player,
            getTrailerVideoData.call(this)
          )}
          addHandler={myListHandler.bind(this)}
          isSavedInMyWatchlist={isSavedInMyWatchlist}
          separator={config.get().locales[i18n.getLocale()].separator}
          direction={i18n.getDirection()}
          firstEpisodeAvailable={firstEpisodeAvailable}
          iconButtonPlay={"play"}
          isUserLoggedIn={this.props.applicationState.userLogged}
        />
        {this.isSeries &&
          hasEpisodes &&
          isLoaded &&
          (!episodeSelectorLoaded ? (
            <ArrowScrollStyled
              label={<Loading width="25px" height="25px" text={i18n.get("pages.detail.loadingEpisodes")} />}
            />
          ) : (
            <ArrowScrollFocus
              focusPath="arrowScrollFocus"
              label={i18n.get("global.media.episodes")}
              icon="arrowDown"
              id="detailArrowEpisodeSelector"
              onFocus={trackAndRedirectHandler.bind(
                this,
                PAGE,
                "episodes",
                `${this.props.match.url}/episodes`,
                getEpisodeSelectorData.call(this),
                this.props.history.location.referrer
              )}
              onMouseUp={trackAndRedirectHandler.bind(
                this,
                PAGE,
                "episodes",
                `${this.props.match.url}/episodes`,
                getEpisodeSelectorData.call(this),
                this.props.history.location.referrer
              )}
            />
          ))}
      </DetailPageStyled>
    );
  }
}

const Component = withAppState(withSubtheme(DetailPage));

Component.defaultFocusPath = Detail.defaultFocusPath;

export default Component;
